import { useState } from "react";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";

import "./Modal.scss";
import {
  apenasNumeros,
  getCorretData,
  numerosDecimal,
  numerosEditadoBR,
  valorMoeda,
} from "../../services/Servicos";

export default function ModalEditarRowProduto(props) {
  const user = useSelector((state) => state.userSlice);
  const handlerSimpleClose = () => props.setShow((last) => ({ show: false }));

  const [body, setBody] = useState(props.row);
  const [aplicarATodos, setAplicarATodos] = useState(false);
  const [btn, setBtn] = useState({
    flag: false,
    style: "primary",
    msg: "Salvar",
  });
  const [bodyEdit, setBodyEdit] = useState({});
  const [params, setParams] = useState(
    Object.keys(props.row).map((item) => item)
  );

  const getEditedValue = (params, value) => {
    if (["emissao", "createdAt", "updatedAt"].includes(params))
      return getCorretData(value);
    if (params == "id_filial")
      return (
        user.filiaisList.data.find((item) => item.idFilial == value)
          ?.identificacaoInterna || value
      );
    if (params == "romaneio") return String(value).padStart(7, "0");
    if (
      [
        "altura",
        "largura",
        "comprimento",
        "volume",
        "peso",
        "pos_x",
        "pos_y",
        "pos_z",
      ].includes(params)
    )
      return Number(
        numerosDecimal(apenasNumeros(String(value * 100))).replace(",", ".")
      ).toLocaleString("pt-br", { minimumFractionDigits: 2 });
    if (params == "valor_total") return valorMoeda(value);
    return value;
  };

  const changeValue = (params, value) => {
    if (
      [
        "altura",
        "largura",
        "comprimento",
        "volume",
        "peso",
        "pos_x",
        "pos_y",
        "pos_z",
      ].includes(params)
    )
      return setBodyEdit((last) => ({
        ...last,
        [params]: Number(
          numerosDecimal(apenasNumeros(value)).replace(",", ".")
        ).toLocaleString("pt-br", { minimumFractionDigits: 2 }),
      }));
    if (params.includes("valor_total"))
      return setBodyEdit((last) => ({
        ...last,
        [params]: valorMoeda(
          numerosDecimal(apenasNumeros(value)).replace(",", ".")
        ).toLocaleString("pt-br", { minimumFractionDigits: 2 }),
      }));
    setBodyEdit((last) => ({ ...last, [params]: value }));
  };

  const atualizarPedido = async () => {
    if (!bodyEdit) return;
    setBtn({ flag: true, msg: "Carregando", style: "warning" });
    let bodyL = { ...bodyEdit };

    Object.keys(bodyL).map((i) => {
      if (
        [
          "altura",
          "largura",
          "comprimento",
          "volume",
          "peso",
          "pos_x",
          "pos_y",
          "pos_z",
        ].includes(i)
      ) {
        bodyL[i] = bodyL[i].replaceAll(".", "").replaceAll(",", ".");
      }
    });
    await props.fnRetorno(
      { ...bodyL },
      {
        idProduto: body.id,
        idPedido: body.numero_pedido,
        idCarga: body.cargas_id,
        idFilial: body.id_filial,
      },
      aplicarATodos
    );
    setBtn({ flag: false, msg: "Salvo", style: "success" });

    setTimeout(() => {
      setBtn({ flag: false, msg: "Salvar", style: "primary" });
      props.setShow(false);
    }, 1000);
  };

  return (
    <>
      <Modal
        show={props.show}
        onHide={handlerSimpleClose}
        backdrop="static"
        keyboard={false}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{props.title || "TITULO NÃO INFORMADO"}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ overflow: "auto", margin: "0 20px" }}>
          <Form>
            {params
              .filter(
                (param) =>
                  ![
                    "updated_at",
                    "created_at",
                    "caminhao_carregamento",
                    "step_planejado",
                  ]
                    .map((i) => i.toLowerCase().replaceAll("_", ""))
                    .includes(param.toLowerCase().replaceAll("_", ""))
              )
              .map((item) => (
                <Row className="mb-2" key={`key_param_${item}`}>
                  <Col sm="3">{item}:</Col>
                  <Col>
                    {item == "tipo_carga" ? (
                      <Form.Select
                        defaultValue={getEditedValue(item, body[item])}
                        onChange={(e) =>
                          setBodyEdit((last) => ({
                            ...last,
                            [item]: e.target.value,
                          }))
                        }
                      >
                        <option value="PADRÃO">Padrão</option>
                        <option value="TRANSFERÊNCIA">Transferência</option>
                        <option value="RETORNO">Retorno</option>
                      </Form.Select>
                    ) : (
                      <Form.Control
                        defaultValue={getEditedValue(item, body[item])}
                        value={bodyEdit[item]}
                        disabled={["id", "empresas_id", "qr_sku"].includes(
                          item
                        )}
                        onChange={(e) => changeValue(item, e.target.value)}
                      />
                    )}
                  </Col>
                  <Col sm="3">
                    {item.includes("data_") ? (
                      <Button
                        variant={"dark"}
                        onClick={() =>
                          setBodyEdit((last) => ({
                            ...last,
                            [item]: new Date().toISOString(),
                          }))
                        }
                      >
                        Agora
                      </Button>
                    ) : (
                      ""
                    )}
                    {[
                      "conferido",
                      "planejado",
                      "carregado",
                      "descarregado",
                    ].includes(item) ? (
                      <Button
                        variant={"info"}
                        onClick={() =>
                          setBodyEdit((last) => {
                            if (item == "conferido") {
                              return {
                                ...last,
                                [item]: !last[item],
                                data_conferencia: !last[item]
                                  ? new Date().toISOString()
                                  : "",
                                user_conferencia: !last[item] ? "SUPORTE" : "",
                              };
                            }
                            if (item == "planejado") {
                              return {
                                ...last,
                                [item]: !last[item],
                                data_planejamento: !last[item]
                                  ? new Date().toISOString()
                                  : "",
                                user_planejamento: !last[item] ? "SUPORTE" : "",
                              };
                            }
                            if (item == "carregado") {
                              return {
                                ...last,
                                [item]: !last[item],
                                data_carregamento: !last[item]
                                  ? new Date().toISOString()
                                  : "",
                                user_carregamento: !last[item] ? "SUPORTE" : "",
                              };
                            }
                            if (item == "descarregado") {
                              return {
                                ...last,
                                [item]: !last[item],
                                data_descarregamento: !last[item]
                                  ? new Date().toISOString()
                                  : "",
                                user_descarregamento: !last[item]
                                  ? "SUPORTE"
                                  : "",
                              };
                            }
                            return { ...last };
                          })
                        }
                      >
                        Alterar
                      </Button>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
                
              ))}
            <Row className="mb-2">
              <Col sm="3">Atualizar todos:</Col>
              <Col>
                <Form.Switch
                  checked={aplicarATodos}
                  label={aplicarATodos ? "Aplicar a todos os produtos" : "Não aplicar a todos os produtos"}
                  onChange={(e) => setAplicarATodos(e.target.checked)}
                />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer className="d-flex flex-row">
          <Button
            variant={btn.style}
            onClick={atualizarPedido}
            style={{ width: "fit-content", paddingInline: "40px" }}
          >
            {btn.msg}
            {btn.style == "success" ? <i className="bi bi-check"></i> : ""}
            {btn.style == "warning" ? (
              <Spinner size="sm" animation="border" color="black" />
            ) : (
              ""
            )}
          </Button>
          <Button
            variant="secondary"
            onClick={handlerSimpleClose}
            style={{ width: "fit-content", paddingInline: "40px" }}
          >
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
